// @flow strict

import * as React from 'react'
import { type PropsWithChildren } from '@mondough/public-web-components'

import { type TriptychSectionProps } from '../TriptychSection'
import Triptych from '../TriptychSection'
import SubtitleSection from '../SubtitleSection'

import styles from './BusinessTriptych.module.scss'

export default function BusinessTriptych({
  sections,
  reverse,
  children,
}: PropsWithChildren<
  TriptychSectionProps,
  React.Element<typeof SubtitleSection>,
>) {
  return (
    <Triptych
      className={styles.businessTriptych}
      sections={sections}
      reverse={reverse}
    >
      {children}
    </Triptych>
  )
}
